'use client';

import * as React from 'react';
import BlockUserModalContent from '@/app/dashboard/staff-settings/all-staff/components/block-user-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function BlockUserModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Block User" isOpen={modal?.open === ModalDrawer.BLOCK_USER}>
      <BlockUserModalContent />
    </ModalLayout>
  );
}
